import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./MenuBar.css";
// import { SiHomeassistantcommunitystore } from "react-icons/si";
import { Grid, Box, Button, Typography } from "@mui/material";
import treatments from "../SideMenuBar/medicine.png";
import hospital from "../SideMenuBar/hospital.png";
import locationCity from "../SideMenuBar/locationCity.png";
import life_protection from "../SideMenuBar/life-protection.png";
import speedometer from "../SideMenuBar/speedometer.png";
import medical_vare from "../SideMenuBar/medical-care.png";
import agreements from "../SideMenuBar/contract.png";
import addNewButton from "../SideMenuBar/add new.png";
import logOut from "../SideMenuBar/logout.png";
import Tooltips from "../ToolTip/ToolTip";
import SliderPopUp from "../SliderPopUp/SliderPopUp";
import AddIcon from "@mui/icons-material/Add";
import { checkPermission } from "../../Utils/Permissions";
import { Group } from "../../Assets/Icons/Group";
function MyHeader({ setIsLogin }) {
  const [isClick, setIsClick] = React.useState(false);
  const [isSlideOpen, setIsSlideOpen] = React.useState(false);
  const navigate = useNavigate();
  const navItems = [
    {
      id: 2,
      path: "hospital",
      menuIcons: hospital,
      navName: "Center",
      altName: "hospital",
    },
    {
      id: 3,
      path: "doctors",
      menuIcons: medical_vare,
      navName: "Professional",
      altName: "",
    },
    {
      id: 4,
      path: "treatments",
      menuIcons: treatments,
      navName: "Treatments",
      altName: "medical-care",
    },
    {
      id: 5,
      path: "cities",
      menuIcons: locationCity,
      navName: "Cities",
      altName: "locationCity",
    },
    {
      id: 6,
      path: "insurance",
      menuIcons: life_protection,
      navName: "Insurance",
      altName: "life-protection",
    },
    // {
    //   id: 7,
    //   path: "agreements",
    //   menuIcons: agreements,
    //   navName: "Agreements",
    //   altName: "contract",
    // },
  ];

  function logout() {
    const confirmBox = window.confirm("Are you sure you want to logout?");
    if (confirmBox === true) {
      localStorage.removeItem("token");
      localStorage.removeItem("isLogin");
      setIsLogin(false);
      navigate("/", { replace: true });
    }
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      <div
        style={{
          width: "75px",
          height: "170px",
          borderRadius: "10px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-around",
          justifyItems: "center",
          backgroundColor: "#414851",
        }}
      >
        <div
          style={{
            flex: 0,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="db-header">
            <div className="db-content">
              <h2 style={{ margin: "5px 0px" }}>DB</h2>
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <div
            onClick={() => navigate("/mySpace")}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "5px",
            }}
          >
            <Box
              sx={{ width: "22px" }}
              component={"img"}
              src={speedometer}
              alt={"DashBoard"}
            />
            <span id="header1">My Space</span>
          </div>
        </div>

        <div
          style={{
            flex: 0,
            display: "flex",
            justifyContent: "center",
          }}
        >
          {checkPermission("DB_DOCTOR_DETAILS_EDIT") &&
            checkPermission("DB_HOSPITAL_DETAILS_EDIT") && (
              <Button
                onClick={() => {
                  setIsClick(!isClick);
                  setIsSlideOpen(!isSlideOpen);
                }}
              >
                <Grid
                  sx={{
                    width: 35,
                    height: 35,
                    backgroundColor: isClick ? "#17dfba" : "white",
                    borderRadius: 100,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <AddIcon
                    sx={{
                      color: "black",
                      width: "35px",
                      transform: isClick ? "rotate(48deg)" : "rotate(0deg)",
                      transition: "all 0.2s linear",
                    }}
                  />
                </Grid>
              </Button>
            )}
        </div>
      </div>

      {/* <div
        style={{
          width: "75px",
          borderRadius: "10px",
          backgroundColor: "#414851",
          display: "flex",
          justifyContent: "center",
          justifyItems: "center",
          paddingTop: "15px",
          paddingBottom: "10px",
        }}
      >
        <div
          onClick={() => navigate("/approvalsPending")}
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            gap: "5px",
          }}
        >
          <Group />
          <span id="header1">Pending</span>
        </div>
      </div> */}

      <Grid item direction="column" className="sidemenu-bar">
        <div
          style={{
            flex: 6,
          }}
        >
          <div className="">
            {navItems.map((items) => {
              return (
                <NavLink to={items.path} id="router" key={items.id}>
                  <Box
                    sx={{ width: "22px" }}
                    component={"img"}
                    src={items.menuIcons}
                    alt={items.altName}
                  />
                  <span id="header1">{items.navName}</span>
                </NavLink>
              );
            })}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            marginBottom: "15px",
          }}
        >
          <Button>
            <Grid
              container
              justifyContent={"center"}
              alignItems={"center"}
              sx={{
                width: 35,
                height: 35,
                backgroundColor: "#67707e",
                borderRadius: 100,
                color: "white",
                cursor: "pointer",
              }}
            >
              <Tooltips />
            </Grid>
          </Button>

          <Button>
            <Box onClick={() => logout()} component={"img"} src={logOut} />
          </Button>
        </div>
        {isSlideOpen && (
          <SliderPopUp
            setIsSlideOpen={(isSlideOpen) => setIsSlideOpen(isSlideOpen)}
            setIsClick={(isClickable) => setIsClick(isClickable)}
          />
        )}
      </Grid>
    </div>
  );
}

export default MyHeader;
